import { StateCreator } from 'zustand';
import { IAppStore } from '../../../IAppStore';
import BasemapCategorySlice, { BasemapCategorySliceProps } from './BasemapCategorySlice';

export const defaultBasemapCategoryProps: BasemapCategorySliceProps = {
  selectedBasemapByCategory: {},
};

const createBasemapCategorySlice: StateCreator<
  IAppStore,
  [],
  [],
  BasemapCategorySlice
> = (set, get) => ({
  ...defaultBasemapCategoryProps,
  setSelectedBasemapCategory: (categoryId: string, basemapId: string) =>
    set({
      selectedBasemapByCategory: {
        ...get().selectedBasemapByCategory,
        [categoryId]: basemapId,
      },
      selectedBasemapId: basemapId,
    }),
});

export default createBasemapCategorySlice;
